import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcDmvHearingFeeDetails from './NcDmvHearingFeeDetails';

const NcDmvHearingFeeModal = ({ selectedHearingFee, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Driver&apos;s License Number: {selectedHearingFee.driversLicenseNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcDmvHearingFeeDetails selectedHearingFee={selectedHearingFee} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcDmvHearingFeeModal;

NcDmvHearingFeeModal.propTypes = {
  selectedHearingFee: PropTypes.instanceOf(Object).isRequired,
};
